import { CommonAPIService } from "@/serviceHandlers/CommonHandler";

export default class ClientsAPIService {
  constructor() {
    this.commonAPIservice = new CommonAPIService();
  }

  getClientInfo(clientId, router) {
    const url = `/api/clients/${clientId}`;
    return this.commonAPIservice.getCall(url, "", router);
  }

  getClients(router) {
    const url = "/api/clients";
    return this.commonAPIservice.getCall(url, "", router);
  }

  createClient(params, router) {
    const url = "/api/clients";
    return this.commonAPIservice.postCall(url, params, router);
  }

  updateClient(clientId, params, router) {
    const url = `/api/clients/${clientId}`;
    return this.commonAPIservice.putCall(url, params, router);
  }

  deleteClient(clientId, router) {
    const url = `/api/clients/${clientId}`;
    return this.commonAPIservice.deleteCall(url, "", router);
  }

  getClientInsuranceProviders(clientId, router) {
    const url = `/api/clients/${clientId}/insurance-providers`;
    return this.commonAPIservice.getCall(url, "", router);
  }

  assignInsuranceProviders(clientId, providerIds, router) {
    const url = `/api/clients/${clientId}/insurance-providers`;
    const params = { provider_ids: providerIds };
    return this.commonAPIservice.postCall(url, params, router);
  }

  removeInsuranceProviders(clientId, providerIds, router) {
    const url = `/api/clients/${clientId}/insurance-providers`;
    const params = { provider_ids: providerIds };
    return this.commonAPIservice.deleteCall(url, params, router);
  }
}
